import React, { useState, useEffect } from "react";
import {
  CheckCircle,

} from "lucide-react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function Contact() {
  const location = useLocation();
  const [formData, setFormData] = useState({
    iAmA: "Business Owner",
    businessName: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: location.state?.email || "",
    message: "",
  });
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    if (location.state?.email) {
      setFormData(prev => ({ ...prev, email: location.state.email }));
      setTimeout(() => {
        const formEl = document.getElementById("contact-us-form-section");
        if (formEl) {
          formEl.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.state?.email]);

  const handleSubmit = async (e) => {
  e.preventDefault();
  setStatus("submitting");

  try {
    const res = await fetch("https://alphabackend-8y03.onrender.com/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await res.json();
    console.log(data);

    if (res.ok) {
      setStatus("success");
      setFormData({
        iAmA: "Business Owner",
        businessName: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        message: "",
      });
    } else {
      setStatus("error");
    }
  } catch (error) {
    console.error(error);
    setStatus("error");
  }
};

  return (
    <>
      <style>
        {`
          /* ==========================================
             CONTACT PAGE STYLES
             ========================================== */

          /* 1. HERO SECTION STYLES - 2:1 padding ratio (top:bottom) */
          .hero-section {
            position: relative;
            background-color: #f8fafc;
            overflow: hidden;
            border-bottom: 1px solid #e2e8f0;
            /* 2:1 ratio - Top padding is double the bottom padding */
            padding-top: 8rem;
            padding-bottom: 4rem;
          }

          /* Desktop Large */
          @media (min-width: 1024px) {
            .hero-section {
              padding-top: 12rem;
              padding-bottom: 6rem;
            }
          }

          /* Desktop Medium */
          @media (min-width: 768px) and (max-width: 1023px) {
            .hero-section {
              padding-top: 10rem;
              padding-bottom: 5rem;
            }
          }

          /* Mobile */
          @media (max-width: 767px) {
            .hero-section {
              padding-top: 6rem;
              padding-bottom: 3rem;
            }
          }

          .contact-subheading {
            color: #019BD7 !important;
            font-size: 1.1rem !important;
            letter-spacing: 0.25em !important;
            font-weight: 700 !important;
            text-transform: uppercase;
            margin-bottom: 1.5rem;
            display: block;
          }

          .contact-hero-title {
            font-size: clamp(2.5rem, 8vw, 4.5rem) !important;
            line-height: 1.1 !important;
            font-weight: 800 !important;
            color: #203468 !important;
            letter-spacing: -0.02em !important;
            margin-bottom: 2rem !important;
          }

          .contact-description {
            font-size: 1.4rem !important;
            color: #475569 !important;
            line-height: 1.7 !important;
            max-width: 900px !important;
            margin: 0 auto 0 auto !important;
          }

          /* 2. UNDERLINE ANIMATION */
          .underline-container {
            position: relative;
            display: inline-block;
            white-space: nowrap;
            padding-bottom: 5px;
          }

          .underline-container::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -25px;
            width: 100%;
            height: 40px;
            background-image: url("data:image/svg+xml;utf8,<svg width='800' height='50' viewBox='0 0 800 50' xmlns='http://www.w3.org/2000/svg'><path d='M15,38 C100,32 300,28 450,28 C600,28 750,32 785,42 C795,45 798,40 790,35 C750,20 600,15 450,15 C300,15 100,20 15,32 C5,35 5,40 15,38 Z' fill='%23019BD7' /></svg>");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            clip-path: inset(0 100% 0 0);
            animation: pencilUnderline 0.5s ease-out forwards;
            animation-delay: 0.5s;
          }

          @keyframes pencilUnderline {
            0% {
              clip-path: inset(0 100% 0 0);
            }
            100% {
              clip-path: inset(0 0% 0 0);
            }
          }

          /* 3. LEFT SECTION - MAIN CONTENT STYLES */
          .space-y-8 > h2 {
            font-size: 2.5rem !important;
            font-weight: 700 !important;
            color: #203468 !important;
            line-height: 1.2 !important;
            margin-bottom: 1.5rem !important;
            letter-spacing: -0.02em !important;
          }

          /* Highlight Box */
          .bg-slate-50.border-l-4.border-\\[\\#f97316\\] {
            background-color: #f8fafc !important;
            border-left: 4px solid #f97316 !important;
            padding: 1.5rem !important;
            border-radius: 0.5rem !important;
            margin-bottom: 2rem !important;
          }

          .bg-slate-50.border-l-4.border-\\[\\#f97316\\] p {
            color: #334155 !important;
            font-size: 1.1rem !important;
            line-height: 1.6 !important;
            margin: 0 !important;
          }

          /* Contact Details */
          .space-y-4.pt-4 {
            margin-top: 1rem !important;
            padding-top: 1rem !important;
          }

          .space-y-4.pt-4 p {
            color: #475569 !important;
            font-size: 1rem !important;
            margin-bottom: 0.5rem !important;
          }

          .space-y-4.pt-4 p strong {
            color: #203468 !important;
            font-weight: 700 !important;
          }

          /* Trust Text */
          .text-slate-900.font-medium.text-lg {
            color: #203468 !important;
            font-size: 1.1rem !important;
            font-weight: 600 !important;
            margin-top: 1rem !important;
            padding-top: 1rem !important;
            border-top: 1px solid #e2e8f0 !important;
          }

          /* 4. ADDRESS BLOCKS STYLES */
          .address-section {
            margin-top: 2rem;
            margin-bottom: 1rem;
          }

          .address-first {
            width: 100%;
            margin-bottom: 1.5rem;
          }

          .address-row {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1.5rem;
          }

          .address-card {
            background: white;
            border: 1px solid #e2e8f0;
            border-radius: 0.75rem;
            padding: 1.25rem;
            transition: all 0.3s ease;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
          }

          .address-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
            border-color: #019BD7;
          }

          .address-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0.75rem;
            padding-bottom: 0.75rem;
            border-bottom: 2px solid #f1f5f9;
          }

          .address-city {
            font-weight: 700;
            font-size: 0.9rem;
            color: #1e293b;
            letter-spacing: 0.05em;
          }

          .address-flag {
            width: 32px;
            height: 24px;
            object-fit: cover;
            border-radius: 2px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }

          .address-text {
            font-size: 0.85rem;
            color: #475569;
            line-height: 1.5;
            margin-top: 0.5rem;
          }

          @media (max-width: 768px) {
            .address-row {
              grid-template-columns: 1fr;
              gap: 1rem;
            }
            .address-first {
              margin-bottom: 1rem;
            }
            .address-flag {
              width: 28px;
              height: 21px;
            }
          }

          /* 5. LEFT & RIGHT SECTION SPACING */
          .main-contact-section {
            padding: 4rem 2rem !important;
          }

          @media (min-width: 768px) {
            .main-contact-section {
              padding: 5rem 3rem !important;
            }
          }

          @media (min-width: 1024px) {
            .main-contact-section {
              padding: 6rem 4rem !important;
            }
          }

          .left-content-wrapper {
            padding-right: 1rem !important;
          }

          @media (min-width: 1024px) {
            .left-content-wrapper {
              padding-right: 2rem !important;
            }
          }

          .form-wrapper {
            padding-left: 0 !important;
          }

          @media (min-width: 1024px) {
            .form-wrapper {
              padding-left: 1rem !important;
            }
          }

          /* 6. FORM CARD STYLING */
          .form-card {
            background: white;
            border-radius: 1rem;
            padding: 2rem;
            box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.05);
            border: 1px solid #e2e8f0;
          }

          @media (min-width: 768px) {
            .form-card {
              padding: 2.5rem;
            }
          }

          .form-field-spacing {
            margin-bottom: 1.5rem;
          }

          .form-field-spacing:last-child {
            margin-bottom: 0;
          }

          /* 7. FORM ELEMENTS STYLES */
          form.space-y-6 {
            background: white !important;
            padding: 0 !important;
          }

          form .space-y-2 label {
            font-size: 0.875rem !important;
            font-weight: 500 !important;
            color: #1e293b !important;
            margin-bottom: 0.5rem !important;
            display: block !important;
          }

          .text-\\[\\#d97706\\] {
            color: #f97316 !important;
            font-size: 0.75rem !important;
            font-style: italic !important;
            font-weight: normal !important;
          }

          form input,
          form select,
          form textarea {
            width: 100% !important;
            padding: 0.75rem 1rem !important;
            background-color: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0.375rem !important;
            font-size: 0.95rem !important;
            color: #203468 !important;
            transition: all 0.2s ease !important;
          }

          form input:focus,
          form select:focus,
          form textarea:focus {
            border-color: #65a30d !important;
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(101, 163, 13, 0.1) !important;
          }

          form input::placeholder,
          form textarea::placeholder {
            color: #94a3b8 !important;
          }

          select {
            appearance: none !important;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E") !important;
            background-repeat: no-repeat !important;
            background-position: right 1rem center !important;
            background-size: 1.25rem !important;
          }

          button[type="submit"] {
            width: 100% !important;
            background-color: #203468 !important;
            color: white !important;
            font-weight: 600 !important;
            padding: 1rem !important;
            border-radius: 0.375rem !important;
            transition: all 0.3s ease !important;
            letter-spacing: 0.05em !important;
          }

          button[type="submit"]:hover:not(:disabled) {
            background-color: #019BD7 !important;
            transform: translateY(-2px) !important;
          }

          button[type="submit"]:disabled {
            opacity: 0.6 !important;
            cursor: not-allowed !important;
          }

          .bg-green-50 {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;
            border: 1px solid #bbf7d0 !important;
            border-radius: 1rem !important;
            padding: 2rem !important;
          }

          .bg-green-50 .text-green-800 {
            color: #166534 !important;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          form .space-y-6 > div {
            animation: fadeInUp 0.4s ease-out forwards;
            opacity: 0;
          }

          form .space-y-6 > div:nth-child(1) { animation-delay: 0.05s; }
          form .space-y-6 > div:nth-child(2) { animation-delay: 0.1s; }
          form .space-y-6 > div:nth-child(3) { animation-delay: 0.15s; }
          form .space-y-6 > div:nth-child(4) { animation-delay: 0.2s; }
          form .space-y-6 > div:nth-child(5) { animation-delay: 0.25s; }
          form .space-y-6 > div:nth-child(6) { animation-delay: 0.3s; }

          @keyframes contactFloat {
            0% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0); }
          }

          .contact-shape-animate {
            animation: contactFloat 6s ease-in-out infinite;
          }

          @media (max-width: 1024px) {
            .space-y-8 > h2 {
              font-size: 2rem !important;
            }
          }

          @media (max-width: 768px) {
            .space-y-8 > h2 {
              font-size: 1.75rem !important;
            }
            .grid-cols-1.md\\:grid-cols-2.gap-4 {
              gap: 1rem !important;
            }
            form input,
            form select,
            form textarea {
              padding: 0.625rem 0.875rem !important;
            }
            .contact-description {
              font-size: 1rem !important;
            }
            .contact-hero-title {
              font-size: clamp(1.75rem, 6vw, 3rem) !important;
            }
          }
        `}
      </style>

      <div className="bg-white min-h-screen">
        {/* Hero Section - 2:1 padding ratio (top:bottom) */}
        <div className="hero-section">
          <div className="absolute left-0 top-0 w-64 h-full hidden lg:block opacity-50">
            <div className="absolute top-10 left-10 w-4 h-4 rounded-sm bg-[#bbf7d0] animate-float"></div>
            <div className="absolute top-32 left-20 w-8 h-8 rounded-md bg-[#dcfce7] animate-float animation-delay-2000"></div>
            <div className="absolute top-48 left-8 w-12 h-12 rounded-lg bg-[#e2e8f0] animate-float animation-delay-4000"></div>
            <div className="absolute bottom-20 left-0 w-32 h-32 rounded-tr-3xl bg-[#dcfce7] animate-float"></div>
            <div className="absolute bottom-10 left-32 w-16 h-16 rounded-tl-xl bg-[#bbf7d0] animate-float animation-delay-2000"></div>
            <div className="absolute top-1/2 left-12 w-8 h-8 rounded-md border-2 border-slate-200 animate-float animation-delay-4000"></div>
          </div>
          <div className="absolute right-0 top-0 w-64 h-full hidden lg:block opacity-50">
            <div className="absolute top-20 right-10 w-16 h-16 rounded-bl-2xl bg-[#e2e8f0] animate-float animation-delay-2000"></div>
            <div className="absolute top-40 right-24 w-8 h-8 rounded-md bg-[#dcfce7] animate-float animation-delay-4000"></div>
            <div className="absolute bottom-32 right-12 w-12 h-12 rounded-lg bg-[#bbf7d0] animate-float"></div>
            <div className="absolute bottom-10 right-0 w-24 h-24 rounded-tl-3xl bg-[#dcfce7] animate-float animation-delay-2000"></div>
            <div className="absolute top-1/2 right-20 w-10 h-10 rounded-md border-2 border-slate-200 animate-float animation-delay-4000"></div>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            <span className="contact-subheading">CONTACT US</span>

            <h1 className="contact-hero-title">
              Let's Build Your Managed <br />
              <span className="underline-container">
                Offshore Team Together
              </span>
            </h1>

            <p className="contact-description">
              Whether you're an Accountant, Financial Planner, Business Owner
              (or CFO), Mortgage Broker or SMSF Administrator, we're here to
              help you get started with our Managed Offshore Solutions.
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-contact-section max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
            {/* LEFT SECTION */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="left-content-wrapper space-y-8"
            >
              {/* <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
                Let's Reimagine Your Managed Offshore Teams For A New Era
              </h2> */}

              <div className="bg-slate-50 border-l-4 border-[#f97316] p-6 rounded-r-lg">
                <p className="text-slate-600 text-lg leading-relaxed">
                  Let's discuss how our next-gen offshore people solution can
                  deliver scalable, expertly managed offshore teams to support
                  your business growth in today's evolving world.
                </p>
              </div>

              <div className="space-y-4 pt-4">
                <p className="text-slate-900 font-medium text-lg">
                  You can count on us. Give us a call to learn more.
                </p>
                <p className="text-slate-900 text-lg">
                  <strong className="font-bold">Phone:</strong> +1 425 221 6660
                </p>
                <p className="text-slate-900 text-lg">
                  <strong className="font-bold">Email:</strong>{" "}
                  connectus@thealphacpas.com
                </p>
              </div>

              {/* Address Section */}
              <div className="address-section">
                <div className="address-first">
                  <div className="address-card">
                    <div className="address-header">
                      <span className="address-city">HEAD QUARTER - BELLEVUE</span>
                      <img 
                        src="/images/flags/us.webp" 
                        alt="United States flag" width="80" height="53"
                        className="address-flag"
                      />
                    </div>
                    <div className="address-text">
                      136 102nd Ave SE Apt 524 Bellevue WA 98004
                    </div>
                  </div>
                </div>

                <div className="address-row">
                  <div className="address-card">
                    <div className="address-header">
                      <span className="address-city">SURAT</span>
                      <img 
                        src="/images/flags/in.webp" 
                        alt="India flag" width="80" height="53"
                        className="address-flag"
                      />
                    </div>
                    <div className="address-text">
                      215, Unique Square, Causeway, Katargam - 395004
                    </div>
                  </div>
                  <div className="address-card">
                    <div className="address-header">
                      <span className="address-city">AHEMDABAD</span>
                      <img 
                        src="/images/flags/in.webp" 
                        alt="India flag" width="80" height="53"
                        className="address-flag"
                      />
                    </div>
                    <div className="address-text">
                      102, Solaris Business Hub, Naranpura - 380063
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* RIGHT SECTION - FORM */}
            <motion.div
              id="contact-us-form-section"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="form-wrapper"
            >
              <div className="form-card">
                {status === "success" ? (
                  <div className="bg-green-50 border border-green-200 text-green-800 p-8 rounded-xl text-center">
                    <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
                    <h4 className="font-bold text-2xl mb-2">Message Sent!</h4>
                    <p className="text-lg">
                      Thank you for reaching out. We will contact you shortly.
                    </p>
                    <button
                      onClick={() => setStatus("idle")}
                      className="mt-8 text-green-700 font-medium hover:underline"
                    >
                      Send another message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="form-field-spacing space-y-2">
                      <label className="block text-sm font-medium text-slate-700">
                        I am a
                      </label>
                      <select
                        value={formData.iAmA}
                        onChange={(e) =>
                          setFormData({ ...formData, iAmA: e.target.value })
                        }
                        className="w-full px-4 py-3 bg-white border border-slate-300 focus:ring-1 focus:ring-[#65a30d] focus:border-[#65a30d] outline-none transition-all duration-300"
                      >
                        <option>Business Owner</option>
                        <option>Accountant</option>
                        <option>Financial Planner</option>
                        <option>Mortgage Broker</option>
                        <option>SMSF Administrator</option>
                        <option>Other</option>
                      </select>
                    </div>

                    <div className="form-field-spacing space-y-2">
                      <label className="block text-sm text-slate-700">
                        Business name{" "}
                        <span className="text-[#d97706] italic font-normal">
                          (Required)
                        </span>
                      </label>
                      <input
                        type="text"
                        required
                        value={formData.businessName}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            businessName: e.target.value,
                          })
                        }
                        className="w-full px-4 py-3 bg-white border border-slate-300 focus:ring-1 focus:ring-[#65a30d] focus:border-[#65a30d] outline-none transition-all duration-300"
                        placeholder="Business name"
                      />
                    </div>

                    <div className="form-field-spacing space-y-2">
                      <label className="block text-sm text-slate-700">
                        Name{" "}
                        <span className="text-[#d97706] italic font-normal">
                          (Required)
                        </span>
                      </label>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <input
                          type="text"
                          required
                          value={formData.firstName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              firstName: e.target.value,
                            })
                          }
                          className="w-full px-4 py-3 bg-white border border-slate-300 focus:ring-1 focus:ring-[#65a30d] focus:border-[#65a30d] outline-none transition-all duration-300"
                          placeholder="First Name"
                        />
                        <input
                          type="text"
                          required
                          value={formData.lastName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              lastName: e.target.value,
                            })
                          }
                          className="w-full px-4 py-3 bg-white border border-slate-300 focus:ring-1 focus:ring-[#65a30d] focus:border-[#65a30d] outline-none transition-all duration-300"
                          placeholder="Last Name"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 form-field-spacing">
                      <div className="space-y-2">
                        <label className="block text-sm text-slate-700">
                          Phone
                        </label>
                        <input
                          type="tel"
                          value={formData.phone}
                          onChange={(e) =>
                            setFormData({ ...formData, phone: e.target.value })
                          }
                          className="w-full px-4 py-3 bg-white border border-slate-300 focus:ring-1 focus:ring-[#65a30d] focus:border-[#65a30d] outline-none transition-all duration-300"
                          placeholder="Phone number"
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm text-slate-700">
                          Email{" "}
                          <span className="text-[#d97706] italic font-normal">
                            (Required)
                          </span>
                        </label>
                        <input
                          type="email"
                          required
                          value={formData.email}
                          onChange={(e) =>
                            setFormData({ ...formData, email: e.target.value })
                          }
                          className="w-full px-4 py-3 bg-white border border-slate-300 focus:ring-1 focus:ring-[#65a30d] focus:border-[#65a30d] outline-none transition-all duration-300"
                          placeholder="email@example.com"
                        />
                      </div>
                    </div>

                    <div className="form-field-spacing space-y-2">
                      <label className="block text-sm text-slate-700">
                        Tell us more
                      </label>
                      <textarea
                        rows={4}
                        value={formData.message}
                        onChange={(e) =>
                          setFormData({ ...formData, message: e.target.value })
                        }
                        className="w-full px-4 py-3 bg-white border border-slate-300 focus:ring-1 focus:ring-[#65a30d] focus:border-[#65a30d] outline-none transition-all duration-300 resize-y"
                        placeholder="Tell us about your requirements..."
                      ></textarea>
                    </div>

                    {status === "error" && (
                      <p className="text-red-600 text-sm">
                        There was an error sending your message. Please try
                        again.
                      </p>
                    )}

                    <button
                      type="submit"
                      disabled={status === "submitting"}
                      className="w-full bg-[#203468] hover:bg-[#019BD7] text-white font-medium py-4 transition-colors flex items-center justify-center gap-2 disabled:opacity-70"
                    >
                      {status === "submitting" ? "SUBMITTING..." : "SUBMIT"}
                    </button>
                  </form>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
}